import React, { memo } from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function TeamSection() {
  const teamMembers = [{
    name: 'Dan Knight',
    role: 'Co-Founder & CEO',
    bio: "Dan Knight is the Co-Founder of Turnout and a former Partner at Meritech Capital, where he spent nearly four years supporting high-growth technology companies' operations. He previously held strategy roles at Manifold and OpenView, and earned his degree from Northwestern University.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/puQfL52NJjm2xZfDkLctHA/1744810493288_%281%29.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/dan-c-knight/',
      twitter: 'https://x.com/academi_xyz',
      email: 'dan@turnout.info'
    }
  }, {
    name: 'Jordan Zax',
    role: 'Co-Founder & CTO',
    bio: 'Jordan Zax is the Co-Founder and technical lead of Turnout, bringing deep expertise to all events. He previously spent over three years at Palo Alto Networks and holds his M.S. and B.S. from Northwestern University.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1pyF3DYVn7xKC9QrAED7EL/1748397385106.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/jordan-zax/',
      twitter: 'https://x.com/academi_xyz',
      email: 'dan@turnout.info'
    }
  }];
  return <section id="team" className="py-16 bg-white" data-id="element-223">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <AnimatedSection data-id="element-225">
          <div className="text-center mb-12" data-id="element-226">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-227">
              Meet Our Team
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-228">
              The dedicated professionals behind Turnout's exceptional events
            </p>
          </div>
        </AnimatedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-229">
          {teamMembers.map((member, index) => <AnimatedSection key={index} delay={index * 0.2} data-id="element-230">
              <div className="bg-white rounded-lg overflow-hidden shadow-md transition-all duration-300 hover:shadow-lg h-full" data-id="element-231">
                <div className="aspect-w-3 aspect-h-4 relative" data-id="element-232">
                  <img src={member.image} alt={member.name} className="w-full h-64 object-cover object-center" data-id="element-233" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-234"></div>
                </div>
                <div className="p-6 flex flex-col h-[320px]" data-id="element-235">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-236">
                    {member.name}
                  </h3>
                  <p className="text-indigo-600 font-medium mb-3" data-id="element-237">
                    {member.role}
                  </p>
                  <p className="text-gray-600 mb-4 flex-grow" data-id="element-238">{member.bio}</p>
                  <div className="flex space-x-4 mt-auto" data-id="element-239">
                    <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`${member.name}'s LinkedIn profile`} data-id="element-240">
                      <Linkedin size={18} data-id="element-241" />
                    </a>
                    <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`${member.name}'s Twitter profile`} data-id="element-242">
                      <Twitter size={18} data-id="element-243" />
                    </a>
                    <a href={`mailto:${member.social.email}`} className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`Email ${member.name}`} data-id="element-244">
                      <Mail size={18} data-id="element-245" />
                    </a>
                  </div>
                </div>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}